import React from 'react';
import { withRouter } from 'react-router';
import { connect } from "react-redux"
import { slide as HamburgerMenu } from 'react-burger-menu'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faNewspaper, faUnlock, faObjectGroup, faWrench, faBookmark } from '@fortawesome/free-solid-svg-icons'

class Menu extends React.Component {
    loginClick(event) {
        event.preventDefault();
        this.props.history.push('/');
        document.querySelector('.bm-overlay').click()
    }
    newsClick(event) {
        event.preventDefault();
        this.props.history.push('/news');
        document.querySelector('.bm-overlay').click()
    }
    aboutClick(event) {
        event.preventDefault();
        this.props.history.push('/about');
        document.querySelector('.bm-overlay').click()
    }
    settingsClick(event) {
        event.preventDefault();
        this.props.history.push('/settings');
        document.querySelector('.bm-overlay').click()
    }
    // ourBookClick(event) {
    //     event.preventDefault();
    //     window.open("http://amazon.com");
    //     document.querySelector('.bm-overlay').click()
    // }
    render() {
        let width = "30%";
        if (window.cordova) width = "100%";

        // if (window.cordova && window.Statusbar) {
        //     if (utils.isIphoneX() === true)
        //         window.StatusBar.show();
        //     else
        //         window.StatusBar.styleBlackOpaque
        // }

        return (
            <HamburgerMenu width={width} pageWrapId="router" outerContainerId="app" id="push" >
                <a href="#login" onClick={this.loginClick.bind(this)}>
                    <FontAwesomeIcon name="Login" icon={faUnlock} />
                    Login
                </a>
                <a href="#news" onClick={this.newsClick.bind(this)}>
                    <FontAwesomeIcon name="News" icon={faNewspaper} />
                    News
                </a>
                <a href="#about" onClick={this.aboutClick.bind(this)}>
                    <FontAwesomeIcon name="About" icon={faObjectGroup} />
                    About
                </a>
                <a href="https://www.amazon.com" target="_blank" rel="noopener noreferrer">
                    <FontAwesomeIcon name="Book" icon={faBookmark} />
                    Our Book >>
                </a>
                {window.cordova &&
                    <a href="#settings" onClick={this.settingsClick.bind(this)}>
                        <FontAwesomeIcon name="Settings" icon={faWrench} />
                        Settings
                    </a>
                }
            </HamburgerMenu>
        );
    }
}

export default withRouter(connect()(Menu));